import { Box, Button, Paper, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { buildTimeStringFromTimestamp } from '../../../../../components/common/time/timeHelper'
import GridItem from '../../../../kyc/kycPerson/components/GridItem'
import { PersonStatusBadge } from '../../../components/PersonStatusBadge'
import styles from './styles.module.scss'

export const PersonInfo = ({ person, onEditField, onUpdateStatus }) => {
  const { t } = useTranslation(['common', 'messages'])

  if (!person) return null

  return (
    <Paper elevation={0} className={styles.container}>
      <Box className={styles.header}>
        <Typography variant="h4">
          {person.firstname?.toUpperCase()} {person.lastname?.toUpperCase()}
        </Typography>
        <PersonStatusBadge status={person.status} />
      </Box>

      <Box className={styles.gridItems}>
        <GridItem
          name={t('common:createdAt')}
          value={person.createdAt ? buildTimeStringFromTimestamp(person.createdAt) : '---'}
        />
        <GridItem
          name={t('common:updatedAt')}
          value={person.updatedAt ? buildTimeStringFromTimestamp(person.updatedAt) : '---'}
        />
        <GridItem
          name={t('common:email')}
          value={person.email || '---'}
          editable
          onEditClick={() => onEditField('email', person.email)}
        />
        <GridItem
          name={t('common:externalId')}
          value={person.externalId || '---'}
          editable
          onEditClick={() => onEditField('externalId', person.externalId)}
        />
        <GridItem
          name={t('common:webhookUrl')}
          value={person.webhookUrl || '---'}
          editable
          copyable={!!person.webhookUrl}
          onEditClick={() => onEditField('webhookUrl', person.webhookUrl)}
        />
      </Box>

      <Box className={styles.actions}>
        <Button variant="contained" size="small" onClick={onUpdateStatus}>
          {t('common:updateStatus')}
        </Button>
      </Box>
    </Paper>
  )
}
